var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.7326 10.56V17.4267C25.7326 21.5333 23.386 23.2933 19.866 23.2933H8.14596C7.54596 23.2933 6.97262 23.24 6.43929 23.12C6.10596 23.0667 5.78597 22.9734 5.49264 22.8667C3.49264 22.12 2.2793 20.3867 2.2793 17.4267V10.56C2.2793 6.45331 4.62596 4.69336 8.14596 4.69336H19.866C22.8526 4.69336 24.9993 5.96002 25.5726 8.85335C25.666 9.38669 25.7326 9.93331 25.7326 10.56Z",
    fill: "#090129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7328 14.5601V21.4268C29.7328 25.5335 27.3861 27.2935 23.8661 27.2935H12.1461C11.1595 27.2935 10.2661 27.1602 9.4928 26.8669C7.90613 26.2802 6.82612 25.0669 6.43945 23.1202C6.97279 23.2402 7.54612 23.2935 8.14612 23.2935H19.8661C23.3861 23.2935 25.7328 21.5335 25.7328 17.4268V10.5601C25.7328 9.93347 25.6795 9.37352 25.5728 8.85352C28.1061 9.38685 29.7328 11.1735 29.7328 14.5601Z",
    fill: "#090129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 17.5205C15.9445 17.5205 17.5205 15.9445 17.5205 14.0005C17.5205 12.0564 15.9445 10.4805 14.0005 10.4805C12.0564 10.4805 10.4805 12.0564 10.4805 14.0005C10.4805 15.9445 12.0564 17.5205 14.0005 17.5205Z",
    fill: "#090129"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 11C5.82638 11 5.37305 11.4533 5.37305 12V16C5.37305 16.5467 5.82638 17 6.37305 17C6.91971 17 7.37305 16.5467 7.37305 16V12C7.37305 11.4533 6.93305 11 6.37305 11Z",
    fill: "#090129"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 11C21.0666 11 20.6133 11.4533 20.6133 12V16C20.6133 16.5467 21.0666 17 21.6133 17C22.1599 17 22.6133 16.5467 22.6133 16V12C22.6133 11.4533 22.1733 11 21.6133 11Z",
    fill: "#090129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon1);
export default __webpack_public_path__ + "static/media/ser-icon-1.00d6a63352c999ceb0a587932abc2dcc.svg";
export { ForwardRef as ReactComponent };